import { useTranslation } from 'react-i18next';

export function WhatIsRevOpsSection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 bg-white">
      <div className="container">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="text-3xl font-bold tracking-tight text-[#1A1F3C] mb-6">
            {t('landing.whatIsRevOps.title')}
          </h2>
          <p className="text-lg leading-relaxed text-[#1A1F3C]/70">
            {t('landing.whatIsRevOps.description')}
          </p>
        </div>
      </div>
    </section>
  );
}
